<!--suppress ALL -->
<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <div class="m-b-24">
          <el-button type="primary" size="small" @click="addCompanyVisable" v-if="this.$hasPerm('B030')">创建公司</el-button>
          <el-button type="primary" size="small" @click="addAccountVisiable" v-if="this.$hasPerm('B015')">创建账号</el-button>
        </div>
        <div class="bg-content padding15">
          <el-form size="small" ref="searchRef">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="角色" label-width="55px">
                  <el-select v-model="searchReq.roleIds" style="width: 100%;" placeholder="请选择" filterable multiple collapse-tags>
                    <template v-for="item in roleRes">
                      <el-option :key="item.id" :label="item.roleName+'(启用)'" :value="item.id" v-if="item.status == '1'"/>
                      <el-option :key="item.id" :label="item.roleName+'(关闭)'" :value="item.id" v-if="item.status == '0'"/>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" label-width="55px">
                  <el-select v-model="searchReq.status" style="width: 100%;" placeholder="请选择" clearable collapse-tags>
                    <template v-for="item in statusList">
                      <el-option
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="姓名/邮箱/手机号" label-width="140px">
                  <el-input v-model="searchReq.key" placeholder="请输入查询条件"/>
                </el-form-item>
              </el-col>
              <el-col :span="4" :offset="0">
                <div class="text right">
                  <el-button type="primary" size="small" plain @click="searchReq.page = 1; accountList();"><i class="fa fa-search"></i> 搜索</el-button>
                  <el-button size="small" @click="searchReq.key = null; searchReq.roleIds = []; searchReq.companyId = [], searchReq.status = ''">重置</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="6" v-if="this.$partB()">
                <el-form-item label="公司" label-width="55px">
                  <el-select v-model="searchReq.companyId" style="width: 100%;" placeholder="请选择" filterable multiple collapse-tags>
                    <template v-for="item in companyNameList">
                      <el-option
                        :key="item.id"
                        :value="item.id"
                        :label="item.companyName"
                        :title="item.companyName">
                        <template>
                          <span v-if="item.companyName.length > 15">{{item.companyName.substring(0,15) + '...'}}</span>
                          <span v-else>{{item.companyName}}</span>
                        </template>
                      </el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="padding15 bg-content">
          <el-table size="small" :data="accountRes.list" @sort-change="sort">
            <!--<el-table-column fixed property="id"  label="ID" min-width="50px"/>-->
            <el-table-column fixed property="userName"  label="登陆名" min-width="100px"/>
            <el-table-column fixed property="email"  label="邮箱" min-width="150px"/>
            <el-table-column fixed property="phone"  label="电话" min-width="80px"/>
            <el-table-column fixed label="状态" min-width="40px">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 1">开启</span>
                <span v-else>关闭</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="companyName"  label="所属机构" min-width="100px"/>
            <el-table-column fixed property="roleName"  label="角色" min-width="70px"/>
            <el-table-column fixed property="createTime"  label="注册时间" min-width="140px" sortable="custom"/>
            <el-table-column fixed property="beforeLoginTime" label="最后登陆时间" min-width="140px" sortable="custom">
              <template slot-scope="scope">
                <div v-if="scope.row.beforeLoginTime === null">--</div>
                <div v-else>{{scope.row.beforeLoginTime}}</div>
              </template>
            </el-table-column>
            <el-table-column fixed property="beforeLoginIp"  label="最后登陆ip" min-width="110px">
              <template slot-scope="scope">
                <div v-if="scope.row.beforeLoginIp === null">--</div>
                <div v-else>{{scope.row.beforeLoginIp}}</div>
              </template>
            </el-table-column>
            <el-table-column fixed label="操作" min-width="100px" v-if="this.$hasPerm('B015')">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateAccountVisiable(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                <!--<el-button type="text" size="small" @click="removeAccount(scope.row.id)"><i class="el-icon-delete"></i>&nbsp;删除</el-button>-->
              </template>
            </el-table-column>
          </el-table>
          <div class="text center margin15-tb">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :total="accountRes.totalRecords"
              :page-size="searchReq.limit"
              :current-page="searchReq.page"
              @current-change="currentChange"
              @size-change="sizeChange">
            </el-pagination>
          </div>
        </div>
        <!-- 创建公司 -->
        <el-dialog title="创建公司" :visible.sync="companyVisible" width="50%" center>
          <div>
            <el-form size="small" label-width="140px">
              <el-form-item label="机构方">
                甲方
              </el-form-item>
              <el-form-item label="公司名称*">
                <el-input placeholder="请输入公司名称" v-model="companyReqBody.companyName"/>
              </el-form-item>
              <el-form-item label="联系电话*">
                <el-input placeholder="请输入联系电话" v-model="companyReqBody.telephone"/>
              </el-form-item>
              <el-form-item label="短信抬头">
                <el-input placeholder="请输入短信抬头" v-model="companyReqBody.messageHead"/>
              </el-form-item>
              <el-form-item label="还款银行">
                <el-input placeholder="请输入还款银行" v-model="companyReqBody.bankName"/>
              </el-form-item>
              <el-form-item label="开户人">
                <el-input placeholder="请输入开户人" v-model="companyReqBody.bankPeople"/>
              </el-form-item>
              <el-form-item label="还款账号">
                <el-input placeholder="请输入还款账号" v-model="companyReqBody.cardNumber"/>
              </el-form-item>
              <el-form-item label="账号到期日*">
                <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择承诺还款时间" v-model="companyReqBody.signEndTime" style="width: 100%;"/>
              </el-form-item>
              <el-form-item label="合同公司名称">
                <el-input placeholder="请输入合同公司名称" v-model="companyReqBody.agreementCompanyName" maxlength="20"/>
              </el-form-item>
              <el-form-item label="营业执照">
                <el-input placeholder="请输入营业执照" v-model="companyReqBody.businessLicense"/>
              </el-form-item>
              <el-form-item label="每日最大导入量">
                <el-input-number :min="-1" :max="99999" placeholder="请输入最大导入量" v-model="companyReqBody.amount" style="width: 100%"/>
              </el-form-item>
              <el-form-item label="策略模板来源公司*">
                <el-select style="width:100%" placeholder="请选择策略模板来源公司" v-model="companyReqBody.companyId" filterable>
                  <template v-for="item in companyRes">
                    <el-option :key="item.id" :label="item.companyName+'(甲方)'" :value="item.id" v-if="item.companyType == 'party_a'"/>
                    <el-option :key="item.id" :label="item.companyName+'(乙方)'" :value="item.id" v-if="item.companyType == 'party_b'"/>
                  </template>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="companyVisible = false" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="addCompany">保存</el-button>
          </div>
        </el-dialog>
        <!-- 创建账号 -->
        <el-dialog :title="title+'账号'" :visible.sync="accountVisible" width="40%" center>
          <div>
            <el-form size="small" label-width="140px">
              <el-form-item label="公司">
                <el-select style="width:100%" placeholder="请选择添加用户公司" v-model="accountReqBody.companyId" filterable :disabled="this.companyDisable">
                  <template v-for="item in companyRes">
                    <el-option :key="item.id" :label="item.companyName+'(甲方)'" :value="item.id" v-if="item.companyType == 'party_a'"/>
                    <el-option :key="item.id" :label="item.companyName+'(乙方)'" :value="item.id" v-if="item.companyType == 'party_b'"/>
                  </template>
                </el-select>
              </el-form-item>

              <el-form-item label="用户名称*">
                <el-input placeholder="请输入用户名称" v-model="accountReqBody.userName" :disabled="this.userNameDisable"/>
              </el-form-item>
              <el-form-item label="邮箱*">
                <el-input placeholder="请输入邮箱" v-model="accountReqBody.email"/>
              </el-form-item>
              <el-form-item label="手机号*">
                <el-input placeholder="请输入手机号" v-model="accountReqBody.phone"/>
              </el-form-item>
              <el-form-item label="密码*">
                <el-input type="password" placeholder="请输入密码" v-model="accountReqBody.password"/>
              </el-form-item>
              <el-form-item label="确认密码*">
                <el-input type="password" placeholder="请输入确认密码" v-model="accountReqBody.confirm"/>
              </el-form-item>
              <el-form-item label="角色*">
                <el-select v-model="accountReqBody.roleId" style="width: 100%;" placeholder="请选择" filterable>
                  <template v-for="item in this.getRoles(accountReqBody.companyId)">
                    <el-option :key="item.id" :label="item.roleName" :value="item.id" :disabled="item.disabled"/>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="坐席号">
                <el-input placeholder="请输入坐席号" v-model="accountReqBody.agentNo"/>
              </el-form-item>
              <el-form-item label="坐席密码">
                <el-input type="password" placeholder="请输入坐席密码" v-model="accountReqBody.agentPassword"/>
              </el-form-item>
              <el-form-item label="状态*">
                <el-switch v-model="accountReqBody.status" active-color="#13ce66" active-text="开启" inactive-color="#ff4949" inactive-text="关闭" :active-value="1" :inactive-value="0"/>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="accountVisible = false" size="small">取 消</el-button>
            <el-button type="primary" size="small" v-if="addAccountShow" @click="addAccount">保存</el-button>
            <el-button type="primary" size="small" v-if="!addAccountShow" @click="updateAccount">更新</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchReq: {
        roleIds: [],
        companyId: [],
        status: '',
        key: null,
        page: 1,
        limit: 10,
        order: 'createTime',
        sort: 'desc'
      },
      accountRes: { 'totalRecords': 0, list: [] },
      roleRes: [],
      companyNameList: [],
      statusList: [{
        value: '1',
        label: '开启'
      },
      {
        value: '0',
        label: '关闭'
      }],
      companyReqBody: {
        companyName: null,
        telephone: null,
        messageHead: null,
        bankName: null,
        bankPeople: null,
        cardNumber: null,
        signEndTime: null,
        companyId: null,
        agreementCompanyName: null,
        businessLicense: null,
        amount: 20000
      },
      accountReqBody: {
        id: null,
        userName: null,
        email: null,
        phone: null,
        password: null,
        confirm: null,
        roleId: null,
        status: null,
        companyId: null,
        agentNo: null,
        agentPassword: null
      },
      companyRes: [],
      companyVisible: false,
      accountVisible: false,
      addAccountShow: true,
      companyDisable: false,
      userNameDisable: false,
      title: null
    };
  },
  methods: {
    addCompanyVisable() {
      this.clearCompanyReq();
      this.companyList();
      this.companyVisible = true;
    },
    addCompany() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/company/addCompany',
        data: this.companyReqBody
      }).then(() => {
        loading.close();
        this.companyVisible = false;
        setTimeout(() => {
          this.addAccountVisiable();
        }, 500);
      }).catch(() => {
        loading.close();
      });
    },
    addAccountVisiable() {
      this.title = '创建';
      this.clearAccountReq();
      this.companyList();
      // 乙方显示公司列表
      if (this.$partB()) {
        this.companyDisable = false;
      } else {
        // 甲方disable 且 选中当前公司
        this.companyDisable = true;
        this.accountReqBody.companyId = this.$account().companyId;
      }
      this.userNameDisable = false;
      this.accountVisible = true;
      this.addAccountShow = true;
    },
    addAccount() {
      if (this.accountReqBody.password !== this.accountReqBody.confirm) {
        this.$notify.error({ title: '提示', message: '两次密码不一致' });
        return;
      }
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/user/add',
        data: this.accountReqBody
      }).then(() => {
        this.accountVisible = false;
        this.accountList();
      });
    },
    updateAccountVisiable(row) {
      console.warn(row);
      this.title = '编辑';
      this.companyList();
      this.copyToAccountReq(row);
      this.companyDisable = true;
      this.userNameDisable = true;
      this.accountVisible = true;
      this.addAccountShow = false;
    },
    updateAccount() {
      if (this.accountReqBody.password !== this.accountReqBody.confirm) {
        this.$notify.error({ title: '提示', message: '两次密码不一致' });
        return;
      }
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: `/user/update/${this.accountReqBody.id}`,
        data: this.accountReqBody
      }).then(() => {
        this.accountVisible = false;
        this.accountList();
      });
    },
    removeAccount(userId) {
      this.$confirm('您确定要删除该用户吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'DELETE',
          url: `/user/remove/${userId}`
        }).then(() => {
          // 刷新
          this.accountList();
        });
      });
    },
    accountList() {
      this.$ajax({
        method: 'POST',
        url: '/user/list',
        data: this.searchReq
      }).then((res) => {
        this.accountRes = res.data;
      });
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.accountList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.accountList();
    },
    roleList() {
      this.$ajax({
        method: 'GET',
        url: '/role/roles'
      }).then((res) => {
        this.roleRes = res.data;
      });
    },
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        this.companyRes = res.data;
        this.companyNameList = res.data;
      });
    },
    sort(column) {
      const prop = column.prop === null ? 'createTime' : column.prop;
      const order = column.order === null ? 'descending' : column.order;
      this.searchReq.order = prop;
      if (order === 'descending') {
        this.searchReq.sort = 'desc';
      }
      if (order === 'ascending') {
        this.searchReq.sort = 'asc';
      }
      this.accountList();
    },
    clearCompanyReq() {
      this.companyReqBody.companyName = null;
      this.companyReqBody.telephone = null;
      this.companyReqBody.messageHead = null;
      this.companyReqBody.bankName = null;
      this.companyReqBody.bankPeople = null;
      this.companyReqBody.cardNumber = null;
      this.companyReqBody.signEndTime = null;
      this.companyReqBody.companyId = null;
      this.companyReqBody.agreementCompanyName = null;
      this.companyReqBody.businessLicense = null;
      this.companyReqBody.amount = 20000;
    },
    clearAccountReq() {
      this.accountReqBody.id = null;
      this.accountReqBody.userName = null;
      this.accountReqBody.email = null;
      this.accountReqBody.phone = null;
      this.accountReqBody.password = null;
      this.accountReqBody.confirm = null;
      this.accountReqBody.roleId = null;
      this.accountReqBody.status = 1;
      this.accountReqBody.companyId = null;
      this.accountReqBody.agentNo = null;
      this.accountReqBody.agentPassword = null;
    },
    copyToAccountReq(row) {
      this.accountReqBody.id = row.id;
      this.accountReqBody.userName = row.userName;
      this.accountReqBody.email = row.email;
      this.accountReqBody.phone = row.phone;
      this.accountReqBody.password = '-@!_#$%+.=123456';
      this.accountReqBody.confirm = '-@!_#$%+.=123456';
      this.accountReqBody.roleId = row.roleId;
      this.accountReqBody.status = row.status;
      this.accountReqBody.companyId = row.companyId;
      this.accountReqBody.agentNo = row.agentNo;
      this.accountReqBody.agentPassword = row.agentPassword;
    },
    getRoles(companyId) {
      if (companyId === null) {
        return [];
      }
      const res = [];
      this.roleRes.forEach((item) => {
        // 归属公司和默认角色
        if (item.common === 1 || item.companyId === companyId) {
          const temp = {
            roleName: item.roleName + (item.common === 1 ? '（默认）' : ''),
            id: item.id
          };
          if (item.status === '0') {
            temp.disabled = true;
          } else {
            temp.disabled = false;
          }
          res.push(temp);
        }
      });
      return res;
    }
  },
  mounted() {
    this.accountList();
    this.roleList();
    this.companyList();
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/account/list.vue